<template>
  <div id="app">
    <div v-show="invalidBrowser" class="left-0 right-0 fixed z-50 mt-2">
      <doe-alert
        class="mx-auto"
        title="Please upgrade your browser"
        :description="['We built the Self-Assessment and Quality Improvement Planning Portal with the latest technologies,', ' and unfortunately your browser doesn’t support these.']"
        :closeable="false"
      />
    </div>
    <span role="status" v-if="$root.isLoading" class="sr-only">Loading, please wait.</span>
    <loading :active.sync="$root.isLoading"></loading>
    <doe-modal
      :is-loading="$root.isLoading"
      :is-open="$root.modalIsOpen"
      :headline="$root.modalHeadline"
      :description="$root.modalDescription"
      :cancellable="$root.modalCancellable"
      :label="$root.modalLabel"
      :withoutCancelBtn="$root.withoutCancelBtn"
    />
    <div class="wrapper">
      <app-header />
      <main>
        <router-view />
      </main>
      <div class="push" aria-hidden="true"></div>
    </div>
    <app-footer class="footer" />
  </div>
</template>

<script>
// import Vue from "vue";
import { mapGetters } from "vuex";
import AppHeader from "@/components/AppHeader";
import AppFooter from "@/components/AppFooter";
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import DoeModal from "@/components/modal/Modal";
import DoeAlert from "@/components/alert/Alert.vue";

export default {

  name: "MainApplication",
  components: {
    AppHeader,
    AppFooter,
    Loading,
    DoeModal,
    DoeAlert
  },
  computed: {
    ...mapGetters(["getRefData"]),
    invalidBrowser() {
      if (navigator.appVersion.indexOf("MSIE 10") !== -1) {
        return true;
      }
      return false;
    },
    
  },
  async mounted() {
    if(this.getRefData && !Object.keys(this.getRefData).length){
      const refData = await this.fetchRefDataFromS3();
      this.$store.commit('SET_REF_DATA',refData);
    }
  },
  methods: {
    async fetchRefDataFromS3() {
      try {
        const resp = './ttsds-properties.json';
      } catch (e) {
        return {};
      }
    }
  }
};
</script>

<style lang="scss">
html,
body,
#app {
  height: 100%;
  margin: 0;
}
.wrapper {
  min-height: 100%;
  margin-bottom: -185px;
}
.footer,
.push {
  height: 185px;
}
@media (min-width: 768px) {
  .wrapper {
    margin-bottom: -120px;
  }
  .footer,
  .push {
    height: 120px;
  }
}

</style>
